import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Center, Text } from "@chakra-ui/react";
import { CoordinatesType } from "../types/";

export const useLocationTableColumns = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "locations",
  });

  const columns = useMemo(
    () => [
      {
        key: "name",
        header: t("name"),
        width: "60%",
      },
      {
        key: "coordinatesType",
        header: t("coordinateType"),
        width: "40%",
        render: (value: CoordinatesType) => {
          const typeLabels = {
            [CoordinatesType.POINT]: t("point"),
            [CoordinatesType.AREA]: t("area"),
            [CoordinatesType.ROUTE]: t("route"),
          };

          const getTypeColors = (type: CoordinatesType) => {
            switch (type) {
              case CoordinatesType.AREA:
                return { bg: "#F3E8FF", color: "#641BA3" };
              case CoordinatesType.POINT:
                return { bg: "#FFEDD5", color: "#92310A" };
              case CoordinatesType.ROUTE:
                return { bg: "#DBEAFE", color: "#1E40AF" };
              default:
                return { bg: "#F3F4F6", color: "#374151" };
            }
          };

          const colors = getTypeColors(value);
          const label = typeLabels[value] || value;

          return (
            <Center
              padding="0px 8px"
              bg={colors.bg}
              color={colors.color}
              alignSelf="start"
              w="auto"
              borderRadius="4px"
              fontSize="11px"
              fontWeight="500"
              minH="20px"
            >
              <Text>{label}</Text>
            </Center>
          );
        },
      },
    ],
    [t]
  );

  return { columns };
};
